import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { SuspenseFallback } from '../../components/SuspenseFallback'

const InvestigationPage = lazy(() =>
  import('../../features/investigation/InvestigationPage').then((m) => ({
    default: m.InvestigationPage,
  })),
)

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/investigations/$id')({
  component: InvestigationSessionRoute,
})

function InvestigationSessionRoute() {
  const { id } = Route.useParams()
  return (
    <Suspense fallback={<SuspenseFallback message="Loading investigation..." />}>
      <InvestigationPage sessionId={id} />
    </Suspense>
  )
}
